import { createAsyncActionTypes } from '../utils';

export const GET_BLOG_POSTS = createAsyncActionTypes('GET_BLOG_POSTS');
export const GET_TOP_STORIES = createAsyncActionTypes('GET_TOP_STORIES');
